import { mask } from 'remask';

export function unmaskCEP(value: string) {
  if (!value) return '';
  const cep = ['99999999'];

  return mask(value, cep);
}
